var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVoteTroll = function SvgIconVoteTroll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-vote-troll",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M1478.973 389.714a8.426 8.426 0 0 0-6.12-1.071c2.631 1.41 3.382 4.877 3.382 4.877Z",
    transform: "translate(-1472.853 -386.282)",
    fill: "#4f5902"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M1482.733 389.714a8.426 8.426 0 0 1 6.12-1.071c-2.631 1.41-3.382 4.877-3.382 4.877Z",
    transform: "translate(-1472.853 -386.282)",
    fill: "#4f5902"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M1480.881 402.282c3.971 0 7-1.351 7-5.353 0-3.322-3.294-10.647-7-10.647s-7 7.325-7 10.647c0 4.002 3.03 5.353 7 5.353Z",
    transform: "translate(-1472.853 -386.282)",
    fill: "#adc764"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "devil-evil",
    transform: "translate(-1472.853 -386.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "m1477.432 391.842 2.141 1.285a1.332 1.332 0 1 1-2.141-1.285Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M1484.679 397.731a5.5 5.5 0 0 0-7.6 0 .667.667 0 1 0 .93.956 4.166 4.166 0 0 1 5.737 0 .667.667 0 1 0 .929-.956Z",
    fill: "#4f5902"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M1483.548 394.209a1.333 1.333 0 0 1-1.308-1.082l2.141-1.285a1.328 1.328 0 0 1-.833 2.367Z",
    fill: "#323232"
  }))));
};
export { SvgIconVoteTroll as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi12b3RlLXRyb2xsIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBpZD0iUGF0aF8yNDYiIGRhdGEtbmFtZT0iUGF0aCAyNDYiIGQ9Ik0xNDc4Ljk3MywzODkuNzE0YTguNDI2LDguNDI2LDAsMCwwLTYuMTItMS4wNzFjMi42MzEsMS40MSwzLjM4Miw0Ljg3NywzLjM4Miw0Ljg3N1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNDcyLjg1MyAtMzg2LjI4MikiIGZpbGw9IiM0ZjU5MDIiLz4KICA8cGF0aCBpZD0iUGF0aF8yNDciIGRhdGEtbmFtZT0iUGF0aCAyNDciIGQ9Ik0xNDgyLjczMywzODkuNzE0YTguNDI2LDguNDI2LDAsMCwxLDYuMTItMS4wNzFjLTIuNjMxLDEuNDEtMy4zODIsNC44NzctMy4zODIsNC44NzdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTQ3Mi44NTMgLTM4Ni4yODIpIiBmaWxsPSIjNGY1OTAyIi8+CiAgPHBhdGggaWQ9IlBhdGhfMjQ4IiBkYXRhLW5hbWU9IlBhdGggMjQ4IiBkPSJNMTQ4MC44ODEsNDAyLjI4MmMzLjk3MSwwLDctMS4zNTEsNy01LjM1MywwLTMuMzIyLTMuMjk0LTEwLjY0Ny03LTEwLjY0N3MtNyw3LjMyNS03LDEwLjY0N0MxNDczLjg4MSw0MDAuOTMxLDE0NzYuOTExLDQwMi4yODIsMTQ4MC44ODEsNDAyLjI4MloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNDcyLjg1MyAtMzg2LjI4MikiIGZpbGw9IiNhZGM3NjQiLz4KICA8ZyBpZD0iZGV2aWwtZXZpbCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE0NzIuODUzIC0zODYuMjgyKSI+CiAgICA8cGF0aCBpZD0iUGF0aF8yNDkiIGRhdGEtbmFtZT0iUGF0aCAyNDkiIGQ9Ik0xNDc3LjQzMiwzOTEuODQybDIuMTQxLDEuMjg1YTEuMzMyLDEuMzMyLDAsMSwxLTIuMTQxLTEuMjg1WiIgZmlsbD0iIzMyMzIzMiIvPgogICAgPHBhdGggaWQ9IlBhdGhfMjUwIiBkYXRhLW5hbWU9IlBhdGggMjUwIiBkPSJNMTQ4NC42NzksMzk3LjczMWE1LjUsNS41LDAsMCwwLTcuNiwwLC42NjcuNjY3LDAsMSwwLC45My45NTYsNC4xNjYsNC4xNjYsMCwwLDEsNS43MzcsMCwuNjY3LjY2NywwLDEsMCwuOTI5LS45NTZaIiBmaWxsPSIjNGY1OTAyIi8+CiAgICA8cGF0aCBpZD0iUGF0aF8yNTEiIGRhdGEtbmFtZT0iUGF0aCAyNTEiIGQ9Ik0xNDgzLjU0OCwzOTQuMjA5YTEuMzMzLDEuMzMzLDAsMCwxLTEuMzA4LTEuMDgybDIuMTQxLTEuMjg1YTEuMzI4LDEuMzI4LDAsMCwxLS44MzMsMi4zNjdaIiBmaWxsPSIjMzIzMjMyIi8+CiAgPC9nPgo8L3N2Zz4K";